// src/data/navData.js

/**
 * Defines the structure for the main sidebar navigation menu.
 * 
 * Each section contains an optional title and an array of navigation items.
 * Each item MUST have:
 * - id: A unique identifier (historically used for state management, less critical now).
 * - label: The text displayed in the sidebar.
 * - icon: An emoji or icon component to display next to the label.
 * - path: The URL path associated with this item, used by `react-router-dom`'s <Link> 
 *         component in `Sidebar.jsx`. Ensure this matches a defined route in `Layout.jsx`.
 *         Use '/' for placeholder routes that are not yet implemented.
 */
export const getNavSections = (t) => [
  {
    title: t('nav.celebrities'),
    items: [
      { id: 'celebrities', label: t('nav.celebritySearch'), icon: '🌟', path: '/celebrities' }, 
    ]
  },
  {
    title: t('nav.linearData'),
    items: [
      { id: 'lineups', label: t('nav.lineups'), icon: '📡', path: '/lineups' },
    ]
  },
  {
    title: t('nav.sports'),
    items: [
      { id: 'sportsOrgs', label: t('nav.sportsOrgs'), icon: '🏆', path: '/sports' }
    ]
  },
  {
    title: '',
    items: [
      { id: 'mySavedItems', label: t('nav.mySavedItems'), icon: '🔖', path: '/saved-items' } 
    ]
  },
  {
    title: 'CARRIER MANAGEMENT',
    items: [
      { id: 'carrierUsers', label: 'Users', icon: '👥', path: '/carrier/users', requiredPermission: 'manager.read' }
    ]
  },
  {
    title: 'ADMIN',
    items: [
      { id: 'adminBackends', label: 'Backends', icon: '🗄️', path: '/admin/backends' },
      { id: 'adminCarriers', label: 'Carriers', icon: '🏢', path: '/admin/carriers' },
      { id: 'adminUsers', label: 'Users', icon: '👥', path: '/admin/users' },
      { id: 'adminPermissions', label: 'Permissions', icon: '🔐', path: '/admin/permissions' },
      { id: 'adminCarrierPermissions', label: 'Carrier Permissions', icon: '🔑', path: '/admin/carrier-permissions' }
    ]
  },
  {
    title: 'TELUS',
    items: [
      { id: 'telusVOD', label: 'VOD', icon: '📺', path: '/telus', requiredPermission: 'telus.read' }
    ]
  }
];

// Main tabs for program details
export const getMainTabs = (t) => [
  { id: 'overview', label: t('tabs.overview') },
  { id: 'seasonsEpisodes', label: t('tabs.seasonsEpisodes') },
  { id: 'castCrew', label: t('tabs.castAndCrew') },
  { id: 'images', label: t('tabs.images') },
  { id: 'seasonImages', label: t('tabs.seasonImages') },
  // { id: 'otherVersions', label: 'Other Versions' }, // Temporarily hidden
  { id: 'videoDescriptors', label: t('tabs.videoDescriptors') },
  { id: 'airings', label: t('tabs.airings') },
  { id: 'availabilities', label: t('tabs.availabilities') },
  { id: 'versions', label: t('tabs.versions') },
  { id: 'sports', label: t('tabs.sports') },
  { id: 'children', label: t('tabs.children') },
  { id: 'encoreAI', label: 'Encore AI' } // Keep as is
];

// Sub tabs for overview section
export const getSubTabs = (t) => [
  { id: 'summary', label: t('subTabs.summary') },
  { id: 'titles', label: t('subTabs.titles') },
  { id: 'descriptions', label: t('subTabs.descriptions') },
  { id: 'releases', label: t('subTabs.releases') },
  { id: 'ratings', label: t('subTabs.ratings') },
  { id: 'awards', label: t('subTabs.awards') }
];
